// removed by extract-text-webpack-plugin
module.exports = {"textExpandButton":"textExpandButton__3AkUF","textShrinkButton":"textShrinkButton__cuwi0"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Talk/index.css
// module id = 1476
// module chunks = 0